import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PrestationPage, PrestationTabs } from '@/features/prestations/components/PrestationPage';

const searchSchema = z.object({
  tab: z.enum(PrestationTabs).optional(),
});

export const Route = createFileRoute('/$commiteeSlug/prestation/{-$id}')({
  component: PrestationPage,
  validateSearch: searchSchema,
});
